import React, { useState } from "react";
import Dropzone, { useDropzone } from "react-dropzone";
import * as storage from "../../../services/firebase/storage.js";
import { Progress } from "semantic-ui-react";
import Icon from "../Icon/index.js";
import browserImageSize from "browser-image-size";

export default function FileUploadBox({ content, initiated, style, pageType, storageUrl, set_wrongFormat, ...props }) {
  const [uploadProgress, set_uploadProgress] = useState(0);

  const validateBeforeUpload = (acceptedFiles) => {
    initiated()
    acceptedFiles.map((file) => {
      if (file.type.split("/")[0] === "video") {
        if(file.type === "video/mp4"){
          const url = URL.createObjectURL(file)
          const video = document.createElement('video')
          video.onloadedmetadata = evt => {
            URL.revokeObjectURL(url)
            
            //if(video.videoWidth === 608 && video.videoHeight === 1080){
              uploadToFirebase(file)
            //}else{
              // Not the right dimensions
              //set_wrongFormat("Your video was : " + video.videoWidth + " x " + video.videoHeight + " pixels, but must be 608 x 1080 pixels.")
            //}
          }
          video.src = url
          video.load() // fetches metadata
        }else{
          //Wrong video format: must be .mp4
          set_wrongFormat("Your video was of format " + file.type.split("/")[1] + " but it must be .mp4.")
        }
      } else {
        if(file.type === "image/jpeg" || file.type === "image/png"){
          browserImageSize(file).then(function (size) {
            
            // => {height: 128, width: 128}
            //if(size.width === 800 && size.height === 800){
              uploadToFirebase(file)
            //}else {
               // Not the right image dimensions
               //set_wrongFormat("Your image was : " + size.width + " x " + size.height + " pixels, but must be 800 x 800 pixels.")
            //}
          });
        } else{
          //Wrong image format: must be one of .jpg or .png
          // set_wrongFormat("Your image was of format " + file.type.split("/")[1] + " but it must be one of .png or .jpg.")
          set_wrongFormat("Your image must be .png or .jpg.")
        }
      }
    });
  };

  function uploadToFirebase(file){
      Object.assign(
        file,
        storage.uploadMedia(
          file,
          pageType,
          storageUrl,
          (progress) => {
            set_uploadProgress(progress);
          },
          (url) => {
            props.onChange(url);
          },
          (err) => {
            set_wrongFormat("Something went wrong, contact administrator.");
            console.error("error defining media, function:  uploadToFirebase ", err);
          }
        )
      );
  }

  const files = [];
  return (
    <>
      <div className="c-dragdrop-container">
        <Dropzone accept={pageType === "video" ? "video/*" : "image/*"} maxFiles={1} onDrop={validateBeforeUpload}>
          {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject }) => (
            <div style={style} {...getRootProps({ className: `c-dragdrop ${isDragActive ? "isDragActive" : ""} ${isDragAccept ? "isDragAccept" : ""} ${isDragReject ? "isDragReject" : ""}` })}>
              <div className="c-progress" style={{ width: uploadProgress + "%" }}></div>
              <input {...getInputProps()} />
              {uploadProgress > 0 ? <span className="c-dragdrop-upload-title">{parseInt(uploadProgress)}%</span> : <span className="c-dragdrop-upload-title">{pageType === "video" ? <Icon icon="video" /> : <Icon icon="picture" />}</span>}
            </div>
          )}
        </Dropzone>
        <aside>
          <ul>{files}</ul>
          <Progress percent={uploadProgress} indicating />
        </aside>
      </div>
    </>
  );
}
